import { LocalizedDateFromUtc, LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { Container, Stack } from '@optimus-web/core';
import { ReservationContract } from '@mews-commander/data-access';
import { ViewFileCard } from '../../../common/components/ViewFileCard';
import { DocumentDetailsItem } from './DocumentDetailsItem';
import { SignatureStatusLabel } from './SignatureStatusLabel';

export const DocumentDetailsTab = ({ contract }: { contract: ReservationContract }) => {
    const detailsItems = [
        { id: 'name', label: lt('Name'), value: contract.name },
        {
            id: 'signatureStatus',
            label: lt('ContractsTableSignatureStatusLabel'),
            value: contract.signatureStatus != null ? <SignatureStatusLabel status={contract.signatureStatus} /> : null,
        },
        {
            id: 'signatureDate',
            label: lt('ContractsTableSignatureDateLabel'),
            value: contract.signatureDate != null ? <LocalizedDateFromUtc utcString={contract.signatureDate} /> : null,
        },
        {
            id: 'expirationDate',
            label: lt('ExpirationDate'),
            value:
                contract.expirationDate != null ? <LocalizedDateFromUtc utcString={contract.expirationDate} /> : null,
        },
        {
            id: 'created',
            label: lt('Created'),
            value: (
                <Stack vertical itemAlignment="end">
                    <LocalizedDateTimeFromUtc utcString={contract.createdUtc} /> {contract.creatorProfileName}
                </Stack>
            ),
        },
        {
            id: 'updated',
            label: lt('Updated'),
            value: (
                <Stack vertical itemAlignment="end">
                    <LocalizedDateTimeFromUtc utcString={contract.updatedUtc} /> {contract.updaterProfileName}
                </Stack>
            ),
        },
        { id: 'notes', label: lt('Notes'), value: contract.notes ?? UnicodeEntity.Dash },
    ];

    return (
        <Container padding={['300', '0', '0', '0']}>
            <Stack vertical spacing="300">
                <ViewFileCard fileName={contract.fileName} fileId={contract.id} size={contract.size} />
                <Stack spacing="150" as="ul" vertical>
                    {detailsItems.map(({ id, label, value }, index) => (
                        <DocumentDetailsItem
                            key={id}
                            label={label}
                            value={value}
                            last={index === detailsItems.length - 1}
                        />
                    ))}
                </Stack>
            </Stack>
        </Container>
    );
};
